<template>
  <base-wrapper :loading="loading">
    <div class="mb-4 flex justify-end gap-2">
      <base-input
        type="search"
        placeholder="Cari kode barang"
        :shadow="false"
        v-model="filter.searchProductCode"
        debounce
        @native-input="loadOrderDetails"
      />
      <base-input
        type="search"
        placeholder="Cari kode supplier"
        :shadow="false"
        v-model="filter.searchOriginOffice"
        debounce
        @native-input="loadOrderDetails"
      />
    </div>
    <datatable
      compact
      :columns="[
        { id: 'code', name: 'Kode Barang' },
        { id: 'order_code', name: 'NO PO' },
        { id: 'qty', name: 'Total PO' },
        { id: 'received_qty', name: 'Datang' },
        { id: 'remainder_qty', name: 'Sisa' },
        { id: 'supplier', name: 'Kode Supplier' },
      ]"
      :total="orderDetails.meta.page.total"
      :perPage="orderDetails.meta.page.perPage"
      :currentPage="orderDetails.meta.page.currentPage"
      @pagechanged="onChangePage"
    >
      <template #tbody="{ classes }">
        <tr
          v-for="orderDetail in orderDetails.data"
          :key="orderDetail.id"
          :class="[classes.tr, 'bg-white']"
        >
          <td :class="classes.td">
            <p class="font-bold text-gray-900">
              {{ orderDetail.attributes.product_code }}
            </p>
          </td>
          <td :class="classes.td">
            {{
              getSingleIncluded(
                orderDetails,
                orderDetail.relationships.order.data.id
              ).attributes.origin_code
            }} /
            {{
              getSingleIncluded(
                orderDetails,
                orderDetail.relationships.order.data.id
              ).attributes.destination_code
            }}
          </td>
          <td :class="classes.td">
            {{ orderDetail.attributes.product_qty | toCurrency }}
          </td>
          <td :class="classes.td">
            {{ orderDetail.attributes.product_received | toCurrency }}
          </td>
          <td :class="classes.td">
            {{
              (orderDetail.attributes.product_qty -
                orderDetail.attributes.product_received)
                | toCurrency
            }}
          </td>
          <td :class="classes.td">
            {{
              getSingleIncluded(
                orderDetails,
                orderDetail.relationships.order.data.id
              ).attributes.origin_office_code
            }}
          </td>
        </tr>
      </template>
    </datatable>
  </base-wrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import { requestMixin } from '../../../../../mixins/request/request';

export default {
  mixins: [requestMixin],
  data() {
    return {
      filter: {
        searchOriginOffice: null,
        searchProductCode: null,
      },
      loading: false,
      orderDetails: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
  },
  methods: {
    async loadOrderDetails(params) {
      this.loading = true;

      const [res, err] = await this.request(`/api/v1/order-details`, {
        params: {
          include: 'order',
          'fields[order-details]':
            'product_code,product_qty,product_received,order',
          'fields[orders]': 'origin_code,destination_code,origin_office_code',
          'filter[is_completed]': false,
          'filter[is_valid_for_payment]': true,
          'filter[search_product]': this.filter.searchProductCode,
          'filter[search_origin_office]': this.filter.searchOriginOffice,
          'filter[destination_office_id]': this.me.office_id,
          'page[size]': 5,
          ...params,
        },
      });

      if (!err) {
        this.orderDetails = res;
      }

      this.loading = false;
    },
    onChangePage(page) {
      this.loadOrderDetails({
        'page[number]': page,
      });
    },
  },
  created() {
    this.loadOrderDetails();
  },
};
</script>
